import { type ReactNode } from 'react';
import './Toolbar.css';

/**
 * Toolbar / FilterBar — 목록 위에 서는 한 줄 (디자인 정본 A4).
 *
 * ★★ **가로 스크롤을 만들지 않는다.** 컨트롤이 넘치면 옆으로 흐르게 두지 말고 **줄을 바꾸거나
 *    「필터」로 접는다** — 가로로 흐르는 줄은 무엇이 더 있는지 보이지 않아 아무도 안 찾는다.
 *
 * ★ 높이 40, 안의 컨트롤은 28(`--h-sm`) — 툴바가 본문보다 두꺼우면 목록이 눌린다.
 */
export interface ToolbarProps {
  /** 왼쪽 — 필터·검색처럼 «무엇을 보는지» 정하는 것. */
  children?: ReactNode;
  /** 오른쪽 — 새로 만들기처럼 «무엇을 하는지». */
  actions?: ReactNode;
  /** 접었을 때 나오는 것. 주면 좁은 화면에서 「필터」 단추 뒤로 들어간다. */
  className?: string;
}

export function Toolbar({ children, actions, className }: ToolbarProps) {
  return (
    <div className={['wc-toolbar', className ?? ''].filter(Boolean).join(' ')} role="toolbar" aria-orientation="horizontal">
      {children != null && <div className="wc-toolbar__main">{children}</div>}
      {actions != null && <div className="wc-toolbar__actions">{actions}</div>}
    </div>
  );
}
